import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function CreateAccount() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', number: '', password: '', confirmPassword: '' });
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!form.username.trim()) newErrors.username = 'Username required';
    if (!form.number.trim()) newErrors.number = 'Number required';
    if (!form.password.trim()) newErrors.password = 'Password required';
    if (form.password !== form.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); return; }
    if (window.Swal) {
      window.Swal.fire({ icon: 'success', title: 'Registered!', text: 'Account created. Please login.' });
    }
    navigate('/login');
  };

  return (
    <div style={{ background: '#202020', minHeight: '100vh' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 fixed-top d-flex justify-content-start" style={{ backgroundColor: '#504f4f', padding: '0.5rem 1rem' }}>
            <div className="col ms-3 mt-2 d-flex align-items-center">
              <img src={logo} style={{ height: '5rem', width: '5rem' }} alt="KW-LOGO" />
              <span style={{ color: '#fff', fontFamily: "'Inria Serif', serif", fontSize: '2rem' }} className="ms-2">KW</span>
              <span style={{ color: '#fff', fontFamily: "'Inria Serif', serif", fontSize: '1.4rem' }} className="ms-1">GOLD &amp; SILVER</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '7rem' }}>
        <div className="col-12 d-flex align-items-center justify-content-center mt-5">
          <div className="fs-1" style={{ color: '#fff' }}>K</div>
          <div className="ms-2 me-2"><img src={logo} style={{ height: '6rem', width: '6rem' }} alt="" /></div>
          <div className="fs-1" style={{ color: '#fff' }}>W</div>
        </div>
        <div className="text-center mt-1 tagline">Gold &amp; Silver Accounting System</div>
        <div className="col-12 loginFormHead text-start">Registration</div>

        <div className="col-12 bgCustomForm my-5 ps-3 pe-3 py-5">
          <form onSubmit={handleSubmit}>
            <div className="col-12 usernameField form-group">
              <label style={{ fontSize: '1.3rem', color: 'black' }}><i className="bi bi-person me-2"></i>Username</label>
              <input type="text" placeholder="username" className={`form-control mt-2 border-dark userName${errors.username ? ' error' : ''}`}
                value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} />
              {errors.username && <span className="error-msg">{errors.username}</span>}
            </div>
            <div className="col-12 passwordField">
              <label className="label2"><i className="bi bi-telephone me-2"></i>Number</label>
              <input type="tel" placeholder="0333 1111111" className={`form-control mt-2 border-dark userName${errors.number ? ' error' : ''}`}
                value={form.number} onChange={e => setForm({ ...form, number: e.target.value })} />
              {errors.number && <span className="error-msg">{errors.number}</span>}
            </div>
            <div className="col-12 passwordField">
              <label className="label2"><i className="bi bi-lock me-2"></i>Create Password</label>
              <input type="password" placeholder="password" className={`form-control mt-2 border-dark userName${errors.password ? ' error' : ''}`}
                value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
              {errors.password && <span className="error-msg">{errors.password}</span>}
            </div>
            <div className="col-12 passwordField">
              <label className="label2"><i className="bi bi-lock me-2"></i>Confirm Password</label>
              <input type="password" placeholder="Enter Confirm Password" className={`form-control mt-2 border-dark userName${errors.confirmPassword ? ' error' : ''}`}
                value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} />
              {errors.confirmPassword && <span className="error-msg">{errors.confirmPassword}</span>}
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <button type="submit" className="d-flex align-items-center justify-content-center loginBtn">Registration</button>
            </div>
          </form>
        </div>

        <div className="row">
          <div className="col-12 or-divider"><span>OR</span></div>
          <div className="col-12 text-center mt-5">
            <button className="googleLogin">
              <i className="fa-brands fa-google iconGoogle me-2"></i>Continue With Google
            </button>
          </div>
          <div className="col-12 py-5 text-center">
            <Link to="/login" className="fs-5 text-decoration-none register">
              Already have an account? Log in Now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
